(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    constructor() {
      super();
      this.menuToggle = this.querySelector('.site-header__menu-toggle');
      this.searchToggles = Array.from(this.querySelectorAll('[data-action="toggle-search"]'));
      this.searchPanel = this.querySelector('.site-header__search-panel');
      this.dropdownToggles = Array.from(this.querySelectorAll('.site-header__dropdown-toggle'));

      this.menuToggle && this.menuToggle.addEventListener('click', () => this.toggleMenu());
      this.searchToggles.forEach(toggle => {
        toggle.addEventListener('click', () => this.toggleSearch());
      });

      // Setup both link and arrow toggle triggers for dropdowns
      const dropdownItems = this.querySelectorAll('.site-header__menu-item.has-dropdown');
      dropdownItems.forEach((item) => {
        const triggerLink = item.querySelector('.site-header__menu-link');
        const triggerToggle = item.querySelector('.site-header__dropdown-toggle');
        
        const toggleDropdown = (e) => {
          const isLinkElement = e.currentTarget.tagName === 'A';
          const isHashLink = isLinkElement && (e.currentTarget.getAttribute('href') === '#' || e.currentTarget.getAttribute('href') === '');
          
          if (!isLinkElement || isHashLink) {
            e.preventDefault();
            e.stopPropagation();
            const isOpen = item.classList.contains('is-open');
            if (isOpen) {
              item.classList.remove('is-open');
              if (triggerToggle) triggerToggle.setAttribute('aria-expanded', 'false');
            } else {
              this.closeAll();
              item.classList.add('is-open');
              if (triggerToggle) triggerToggle.setAttribute('aria-expanded', 'true');
            }
          }
        };

        if (triggerLink) triggerLink.addEventListener('click', toggleDropdown);
        if (triggerToggle) triggerToggle.addEventListener('click', toggleDropdown);
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.closeAll();
        }
      });
    }

    toggleMenu() {
      const isOpen = this.classList.toggle('is-menu-open');
      this.menuToggle.setAttribute('aria-expanded', String(isOpen));
      this.querySelector('.icon-menu').hidden = isOpen;
      this.querySelector('.icon-close').hidden = !isOpen;

      // Lock body scroll when drawer is open
      document.body.style.overflow = isOpen ? 'hidden' : '';

      // Close on backdrop click
      if (isOpen) {
        const nav = this.querySelector('.site-header__nav');
        const closeOnBackdrop = (e) => {
          if (e.target === nav || !nav.contains(e.target)) {
            this.toggleMenu();
            document.removeEventListener('click', closeOnBackdrop);
          }
        };
        // Delay to avoid the current click from immediately closing
        setTimeout(() => document.addEventListener('click', closeOnBackdrop), 10);
      }
    }

    toggleSearch() {
      if (!this.searchPanel) return;
      const isHidden = this.searchPanel.hasAttribute('hidden');
      if (isHidden) {
        this.searchPanel.removeAttribute('hidden');
        this.searchToggles.forEach(toggle => toggle.setAttribute('aria-expanded', 'true'));
        this.searchPanel.querySelector('input').focus();
      } else {
        this.searchPanel.setAttribute('hidden', '');
        this.searchToggles.forEach(toggle => toggle.setAttribute('aria-expanded', 'false'));
      }
    }

    closeAll() {
      this.querySelectorAll('.site-header__menu-item.is-open').forEach((item) => {
        item.classList.remove('is-open');
      });
    }

    connectedCallback() {
      if (this.hasAttribute('data-transparent-init')) {
        this.initScrollBehavior();
      }
    }

    initScrollBehavior() {
      const handleScroll = () => {
        if (window.scrollY > 20) {
          this.classList.add('is-scrolled');
        } else {
          this.classList.remove('is-scrolled');
        }
      };
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  function initHeroBanners() {
    document.querySelectorAll('.hero-banner').forEach(banner => {
      if (banner.dataset.initialized === 'true') return;
      banner.dataset.initialized = 'true';

      const viewport = banner.querySelector('.hero-banner__viewport');
      const slides = Array.from(banner.querySelectorAll('.hero-banner__slide'));
      const dots = Array.from(banner.querySelectorAll('.hero-banner__dot'));
      const prevButton = banner.querySelector('.hero-banner__arrow--prev');
      const nextButton = banner.querySelector('.hero-banner__arrow--next');
      let currentIndex = 0;
      let autoplayTimer = null;

      if (slides.length < 2) return;

      const adjustHeight = () => {
        const activeSlide = slides[currentIndex];
        if (activeSlide && viewport) {
          const activeImage = activeSlide.querySelector('.hero-banner__image');
          if (activeImage) {
            const h = activeImage.offsetHeight;
            if (h > 0) {
              viewport.style.height = `${h}px`;
            }
          }
        }
      };

      const updateActive = (index) => {
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        setTimeout(adjustHeight, 50);
      };

      const goTo = (index) => {
        const total = slides.length;
        const next = (index + total) % total;
        currentIndex = next;
        
        const slide = slides[next];
        if (slide && viewport) {
          const targetLeft = slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
          viewport.scrollTo({
            left: targetLeft,
            behavior: 'smooth'
          });
        }
        updateActive(next);
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => goTo(currentIndex - 1));
      }
      if (nextButton) {
        nextButton.addEventListener('click', () => goTo(currentIndex + 1));
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => goTo(index));
      });

      let scrollTimeout;
      if (viewport) {
        viewport.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            const viewportRect = viewport.getBoundingClientRect();
            let closest = 0;
            let closestDistance = Infinity;
            slides.forEach((slide, index) => {
              const distance = Math.abs(slide.getBoundingClientRect().left - viewportRect.left);
              if (distance < closestDistance) {
                closestDistance = distance;
                closest = index;
              }
            });
            if (closest !== currentIndex) {
              currentIndex = closest;
              updateActive(closest);
            }
          }, 80);
        }, { passive: true });
      }

      if (banner.dataset.autoplay === 'true') {
        const speed = parseInt(banner.dataset.autoplaySpeed, 10) || 6000;
        const start = () => {
          autoplayTimer = setInterval(() => goTo(currentIndex + 1), speed);
        };
        const stop = () => clearInterval(autoplayTimer);
        start();
        banner.addEventListener('mouseenter', stop);
        banner.addEventListener('mouseleave', start);
      }

      // Track active image size dynamically
      window.addEventListener('resize', adjustHeight);
      slides.forEach(slide => {
        const img = slide.querySelector('.hero-banner__image');
        if (img) {
          if (img.complete) {
            adjustHeight();
          } else {
            img.addEventListener('load', adjustHeight);
          }
        }
      });
      setTimeout(adjustHeight, 150);
    });
  }

  // Initialize on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroBanners);
  } else {
    initHeroBanners();
  }

  // Initialize in Shopify Editor when section is customized
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.hero-banner')) {
      initHeroBanners();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-before-after"] && !Shopify.designMode) return;
  try {
    
  const initBeforeAfter = (scope) => {
    (scope || document).querySelectorAll('[data-aq-before-after]').forEach(comparison => {
      const range = comparison.querySelector('[data-aq-before-after-range]');
      if (!range || comparison.dataset.baInitialized) return;
      comparison.dataset.baInitialized = 'true';
      const update = () => {
        comparison.style.setProperty('--comparison-position', `${range.value}%`);
      };
      range.addEventListener('input', update);
      range.addEventListener('change', update);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBeforeAfter(document));
  } else {
    initBeforeAfter(document);
  }
  document.addEventListener('shopify:section:load', (event) => initBeforeAfter(event.target));

  } catch(e) { console.error(e); }
})();
})();
